import React from "react";

interface PriceFilterProps {
  selectedMinPrice?: number;
  selectedMaxPrice?: number;
  sortBy?: "asc" | "desc";
  onMinPriceChange?: (value: number | undefined) => void;
  onMaxPriceChange?: (value: number | undefined) => void;
  onSortChange?: (value: "asc" | "desc" | undefined) => void;
  onApply?: () => void;
  hideButtons?: boolean;
  fullWidth?: boolean;
}

export const PriceFilter: React.FC<PriceFilterProps> = ({
  selectedMinPrice,
  selectedMaxPrice,
  sortBy,
  onMinPriceChange,
  onMaxPriceChange,
  onSortChange,
  onApply,
  hideButtons = false,
  fullWidth = false,
}) => {
  return (
    <div className={`${fullWidth ? "w-full" : "w-[300px]"} lg:p-4 space-y-4`}>
      {/* Price Range */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="text-sm font-medium text-gray-700 mb-2">Minimum</div>
          <select
            value={selectedMinPrice || ""}
            onChange={(e) =>
              onMinPriceChange?.(
                e.target.value ? parseInt(e.target.value, 10) : undefined
              )
            }
            className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-1 focus:border-primary"
          >
            <option value="">No Min</option>
            {[
              50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000,
              450000, 500000, 600000, 700000, 800000, 900000, 1000000,
            ].map((price) => (
              <option key={price} value={price}>
                ${price.toLocaleString()}
              </option>
            ))}
          </select>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-700 mb-2">Maximum</div>
          <select
            value={selectedMaxPrice || ""}
            onChange={(e) =>
              onMaxPriceChange?.(
                e.target.value ? parseInt(e.target.value, 10) : undefined
              )
            }
            className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-1 focus:border-primary"
            disabled={false}
          >
            <option value="">No Max</option>
            {[
              100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000,
              900000, 1000000, 1500000, 2000000, 2500000, 3000000,
            ]
              .filter((price) => !selectedMinPrice || price > selectedMinPrice)
              .map((price) => (
                <option key={price} value={price}>
                  ${price.toLocaleString()}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Sort By */}
      {/* <div>
        <div className="text-sm font-medium text-gray-700 mb-2">Sort By</div>
        <select
          value={sortBy || ""}
          onChange={(e) =>
            onSortChange?.(e.target.value as "asc" | "desc" | undefined)
          }
          className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-1 focus:border-primary"
        >
          <option value="">No Sort</option>
          <option value="asc">Price: Low to High</option>
          <option value="desc">Price: High to Low</option>
        </select>
      </div> */}

      {/* Action Buttons */}
      {!hideButtons && (
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => {
              onMinPriceChange?.(undefined);
              onMaxPriceChange?.(undefined);
              onSortChange?.(undefined);
            }}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 !bg-transparent"
          >
            Reset
          </button>
          <button
            type="button"
            onClick={onApply}
            className="flex-1 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:opacity-90 transition-opacity"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default PriceFilter;
